export default __webpack_public_path__ + "static/media/protoAndGoLogo.fad415ea.png";